"use strict";

import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import { onReady } from '../core/ready.js';

onReady(() => {
    initCasesPage();
});

function initCasesPage() {
    const linksSlider = document.getElementById('linksSlider');

    if (linksSlider) {
        const nextEl = linksSlider.querySelector('.swiper-button-next');
        const prevEl = linksSlider.querySelector('.swiper-button-prev');

        new Swiper(linksSlider, {
            modules: [Navigation],
            loop: false,
            slidesPerView: 1,
            spaceBetween: 0,
            centeredSlides: false,
            navigation: nextEl && prevEl ? {
                nextEl,
                prevEl,
            } : undefined,
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 0,
                }
            }
        });
    }
}
